var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 1.85686H0.857143C0.629814 1.85686 0.411797 1.76656 0.251051 1.60581C0.0903059 1.44507 0 1.22705 0 0.999721C0 0.772393 0.0903059 0.554375 0.251051 0.39363C0.411797 0.232884 0.629814 0.142578 0.857143 0.142578H11.1429C11.3702 0.142578 11.5882 0.232884 11.7489 0.39363C11.9097 0.554375 12 0.772393 12 0.999721C12 1.22705 11.9097 1.44507 11.7489 1.60581C11.5882 1.76656 11.3702 1.85686 11.1429 1.85686Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.575a238749b7d042ef9a961b377e745b.svg";
export { ForwardRef as ReactComponent };